import jwtDecode from 'jwt-decode';

/**
 * JWT가 없거나 손상됐거나 이미 만료됐는지 판단합니다.
 *
 * 서버와 브라우저 시계 차이 및 요청 전송 시간을 고려해 기본 30초의 안전 여유를 둡니다.
 * 파싱할 수 없는 저장값은 재사용하지 않고 만료로 취급하여 새 DEVICE 토큰을 받게 합니다.
 */
export function isJwtExpired(
  token,
  nowMillis = Date.now(),
  safetyWindowSec = 30,
) {
  if (!token) return true;

  try {
    const payload = jwtDecode(token);
    if (typeof payload?.exp !== 'number') return true;
    return payload.exp <= Math.floor(nowMillis / 1000) + safetyWindowSec;
  } catch {
    return true;
  }
}
